import React from "react";
import GovAgency from "../components/MHSSS Accounting/govAgencies/addMoney/pay";

const Gov = () => {
  return (
    <div>
      <GovAgency />
    </div>
  );
};

export default Gov;
